export default {
  haveSameContents(a, b) {
    for (const v of new Set([...a, ...b]))
      if (a.filter(e => e === v).length !== b.filter(e => e === v).length)
        return false
    return true
  },
  getWidthHeightByImg({ document, img, width }) {
    const imgProps = document.getImageProperties(img)
    const height = (imgProps.height * width) / imgProps.width
    return { width, height }
  },
}
